import SiteHeader from "containers/SiteHeader";
import React, { ReactNode, useEffect } from "react";
import { PrivateRoute } from "routers/PrivateRoute";
import Footer from "shared/Footer/Footer";
import { Toaster } from "react-hot-toast";
import { MetadataUserProvider } from "contexts/metadata-user-context";
import BannerHeader from "components/HeaderBannerAccount";
import { useLocation } from 'react-router-dom';
import { useHotels } from "contexts/HotelsSearchContext/HotelProvider";

interface MainTemplateProps {
  children: ReactNode;
}

export const MainTemplate: React.FC<MainTemplateProps> = ({ children }) => {
  const { setSearchEngine } = useHotels();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/" || location.pathname === "/home") {
      setSearchEngine(false);
    }
    if (window.innerWidth < 768) {
      setSearchEngine(true);
    }

  }, []);

  return (
    <MetadataUserProvider>
      <PrivateRoute>
        <Toaster position="top-center" />
        <main className="w-full min-h-[calc(100svh-144px)]">
          <SiteHeader />
          <BannerHeader />
          {children}
        </main>
        <Footer />
      </PrivateRoute>
    </MetadataUserProvider>
  );
};
